import { axios } from '@pukka/auth';
import { MOKA_GOAUTH_SERVICE } from '@pukka/common/constants';

import { PaymentConfigModel } from '../models';

const GET_ALL_PAYMENT_METHODS_URL = `${MOKA_GOAUTH_SERVICE}/payment-config/v1/payment-methods`;

async function getAllPaymentMethods(): Promise<PaymentConfigModel.PaymentMethod[]> {
  const { data } = await axios.get(GET_ALL_PAYMENT_METHODS_URL);

  return data;
}

export { GET_ALL_PAYMENT_METHODS_URL, getAllPaymentMethods };
